import * as React from 'react'
import classNames from 'classnames'

type StackSpace = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export interface Props {
  displayClasses?: string
  space: StackSpace
}

const Stack: React.FC<Props> = ({displayClasses, children, space}) => {
  const classes = classNames('stack', displayClasses, space)

  return <div className={classes}>{children}</div>
}

export default Stack
